import i18n from 'i18next';

export const columns = [
  {
    id: 'dotNumber',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('usDotManagement.usDotNo'),
  },
  {
    id: 'carrierName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('usDotManagement.carrierName'),
  },
  {
    id: 'mainAddress',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('usDotManagement.mainAddress'),
  },
  {
    id: 'city',
    numeric: false,
    needSorting: true,
    disablePadding: false,
    label: i18n.t('common.city'),
  },
  {
    id: 'state',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.state'),
  },
  {
    id: 'zipCode',
    numeric: false,
    needSorting: true,
    disablePadding: false,
    label: i18n.t('common.zipCode'),
  },
  {
    id: 'actions',
    label: i18n.t('Actions'),
  },
];
